"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var nanoid_1 = require("nanoid");
var React = __importStar(require("react"));
var react_table_1 = require("react-table");
var icons_1 = require("../icons");
var styles_1 = require("./styles");
var Table = function (props) {
    // Use the state and functions returned from useTable to build your UI
    var memoizedColumns = React.useMemo(function () { return props.columns; }, [props]);
    var memoizedData = React.useMemo(function () { return props.rows; }, [props]);
    var _a = (0, react_table_1.useTable)({
        columns: memoizedColumns,
        data: memoizedData,
        initialState: props.sort
            ? {
                sortBy: [__assign({}, props.sort)],
            }
            : undefined,
    }, react_table_1.useSortBy), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, rows = _a.rows, prepareRow = _a.prepareRow;
    var SortIcon = function () { var _a; return !((_a = props.sort) === null || _a === void 0 ? void 0 : _a.desc) ? React.createElement(icons_1.ArrowGroupUpIcon, null) : React.createElement(icons_1.ArrowGroupDownIcon, null); };
    return (React.createElement(styles_1.TableStyles, __assign({}, getTableProps(), props),
        React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (
        // We don't need keys here since react-table provides them for us
        // eslint-disable-next-line react/jsx-key
        React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column, i) {
            var _a;
            return ((_a = props.sort) === null || _a === void 0 ? void 0 : _a.id) === column.id ? (React.createElement(styles_1.TableHeaderStyles, __assign({}, column.getHeaderProps(), { key: "".concat(i, "-").concat((0, nanoid_1.nanoid)()) }),
                React.createElement(SortIcon, null),
                column.render('Header'))) : (React.createElement("th", { key: "".concat(i, "-").concat((0, nanoid_1.nanoid)()) },
                " ",
                column.render('Header')));
        }))); })),
        React.createElement("tbody", __assign({}, getTableBodyProps()), rows.map(function (row) {
            prepareRow(row);
            return (
            // We don't need keys here since react-table provides them for us
            // eslint-disable-next-line react/jsx-key
            React.createElement("tr", __assign({}, row.getRowProps()), row.cells.map(function (cell) { return (
            // We don't need keys here since react-table provides them for us
            // eslint-disable-next-line react/jsx-key
            React.createElement("td", __assign({}, cell.getCellProps()), cell.render('Cell'))); })));
        }))));
};
exports.Table = Table;
//# sourceMappingURL=index.js.map